(function() {
  'use strict';
  let tabs, items, grid;
  const SELECTOR_TAB = '[data-tab]';
  const SELECTOR_ITEM = '[data-content-item]';
  const SELECTOR_GRID = '[data-all-contents-grid]';
  const ACTIVE_TAB_CLASS = 'is-active';
  function getElements() {
    tabs = document.querySelectorAll(SELECTOR_TAB);
    items = document.querySelectorAll(SELECTOR_ITEM);
    grid = document.querySelector(SELECTOR_GRID);
    return items.length > 0 && grid !== null;
  }
  function updateLastRowClasses() {
    if (!grid) return;
    const columns = parseInt(grid.dataset.gridColumns, 10) || 4;
    const allItems = grid.querySelectorAll(SELECTOR_ITEM);
    allItems.forEach(item => item.classList.remove('is-last-row'));
    const visibleCards = grid.querySelectorAll(`${SELECTOR_ITEM}:not(.hidden)`);
    if (visibleCards.length === 0) return;
    const remainder = visibleCards.length % columns;
    const lastRowCount = remainder === 0 ? columns : remainder;
    [...visibleCards]
      .slice(-lastRowCount)
      .forEach(card => card.classList.add('is-last-row'));
  }
  function filterByType(type) {
    if (!items || items.length === 0) return;
    items.forEach(item => {
      const itemType = item.dataset.type || '';
      const itemTypeLower = itemType.toLowerCase();
      const filterTypeLower = type.toLowerCase();
      if (type === 'all' || itemTypeLower === filterTypeLower) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
    updateLastRowClasses();
  }
  function setupEventListeners() {
    if (tabs && tabs.length > 0) {
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => {
            t.classList.remove(ACTIVE_TAB_CLASS);
            t.removeAttribute('data-active');
          });
          tab.classList.add(ACTIVE_TAB_CLASS);
          tab.setAttribute('data-active', 'true');
          const type = tab.dataset.type || 'all';
          filterByType(type);

          // Update sliding underline position
          const container = tab.closest('[data-sliding-underline]');
          if (container && container._slidingUnderline) {
            container._slidingUnderline.setActive(tab);
          }
        });
      });
    }
  }
  function initializeActiveTab() {
    if (!getElements()) {
      return false;
    }
    if (tabs && tabs.length > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      const typeParam = urlParams.get('type');
      let activeTab = null;
      if (typeParam) {
        const typeParamLower = typeParam.toLowerCase();
        tabs.forEach(tab => {
          const tabType = tab.dataset.type || '';
          const tabTypeLower = tabType.toLowerCase();
          if (tabTypeLower === typeParamLower) {
            activeTab = tab;
          }
        });
      }
      if (!activeTab) {
        activeTab = document.querySelector(`${SELECTOR_TAB}[data-active="true"]`);
      }
      if (!activeTab) {
        activeTab = tabs[0];
      }
      tabs.forEach(t => {
        t.classList.remove(ACTIVE_TAB_CLASS);
        t.removeAttribute('data-active');
      });
      activeTab.classList.add(ACTIVE_TAB_CLASS);
      activeTab.setAttribute('data-active', 'true');
      filterByType(activeTab.dataset.type || 'all');

      // Update sliding underline position
      var container = activeTab.closest('[data-sliding-underline]');
      if (container && container._slidingUnderline) {
        container._slidingUnderline.setActive(activeTab);
      }
    } else {
      updateLastRowClasses();
    }
    return true;
  }
  function init() {
    if (initializeActiveTab()) {
      setupEventListeners();
    } else {
      setTimeout(init, 100);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();